import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Checkbox,
  Input,
  Stack,
  FormHelperText,
  CheckboxGroup,
} from "@chakra-ui/react";

import { Field } from "formik";

const CheckBox = ({ options, formik, id, optionslength }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const checkBoxErrors =
    Object.keys(formik.errors).length &&
    formik.errors.checkBox &&
    formik.errors.checkBox.length &&
    formik.errors.checkBox[id];
  const checkBoxTouched =
    Object.keys(formik.touched).length &&
    formik.touched.checkBox &&
    formik.touched.checkBox.length &&
    formik.touched.checkBox[id];
  const hasError = checkBoxTouched && checkBoxErrors;

  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel fontSize="14px">{options.label}</FormLabel>
      )}
      {options.choices.map((element, index) => {
        return (
          <div
            key={("label-", index)}
            margin-right="4%"
            role="group"
            aria-labelledby="checkbox-group"
          >
            <label key={("label-", index)}>
              <Field
                style={{
                  marginRight: "1%",
                }}
                name={`checkBox.${id}.${options.label}`}
                value={element.name}
                type="checkbox"
                checked={element.checked}
              />
              {element.name}
            </label>
          </div>
        );
      })}
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.checkBox}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default CheckBox;
